<template>
  <div :class="elementClass" @click="elOnClick()">
    <input
      ref="radio"
      :checked="value === val"
      @click="thumbOnClick"
      @change="$emit('input', val)"
      type="radio"
      :disabled="disabled"
      :name="name"
      :value="val"
    />
    <div ref="ripple" class="mad-radio-ripple"></div>
    <mad-icon class="mad-radio-uncheck" :name="uncheckIcon">{{ uncheckIcon }}</mad-icon>
    <mad-icon class="mad-radio-check" :name="checkIcon">{{ checkIcon }}</mad-icon>
    <div class="mad-radio-label" v-if="label">{{ label }}</div>
  </div>
</template>

<script>
import { radioClass } from "../prefix";
import Helper from "../helper";
export default {
  props: {
    value: {},
    val: {},
    disabled: {
      default: false,
    },
    name: {
      default: "",
    },
    checkIcon: {
      default: "mdiRadioboxMarked",
    },
    uncheckIcon: {
      default: "mdiRadioboxBlank",
    },
    label: {
      default: "",
    },
  },
  computed: {
    elementClass() {
      return radioClass;
    },
  },
  methods: {
    elOnClick() {
      this.$refs.radio.click();
    },
    thumbOnClick() {
      this.$emit("click");
      Helper.addClass(this.$refs.ripple, "active");
      setTimeout(() => {
        Helper.removeClass(this.$refs.ripple, "active");
      }, 300);
    },
  },
};
</script>
<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-radio";

$colorCodeSet: $theme-primary, $theme-accent, $color-red, $color-pink, $color-purple, $color-deep-purple, $color-indigo, $color-blue,
  $color-light-blue, $color-cyan, $color-teal, $color-green, $color-light-green, $color-lime, $color-yellow, $color-amber, $color-orange,
  $color-deep-orange, $color-brown, $color-blue-grey;
$colorNameSet: "primary", "accent", "red", "pink", "purple", "deep-purple", "indigo", "blue", "light-blue", "cyan", "teal", "green", "light-green",
  "lime", "yellow", "amber", "orange", "deep-orange", "brown", "blue-grey";

@mixin generateCreateRadio($className) {
  @for $i from 1 to length($colorNameSet) {
    @include createRadio($className, nth($colorNameSet, $i), nth($colorCodeSet, $i));
  }
}

@mixin createRadio($className, $colorName, $colorCode) {
  &.#{$colorName} {
    #{$className}-check {
      color: $colorCode;
    }
    input[type="radio"] {
      &:checked ~ #{$className}-ripple {
        background-color: rgba($colorCode, 0.2);
      }
    }
  }
}

#{$element} {
  height: 44px;
  width: 100%;
  cursor: pointer;
  float: left;
  #{$element}-check,
  #{$element}-uncheck {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 10px;
    left: 0px;
    z-index: 2;
  }
  #{$element}-check {
    color: $theme-primary;
    @include transform(scale(0));
    @include transition((all 0.2s $animation-standard-curve-timing-function, opacity 0.25s $animation-standard-curve-timing-function));
    opacity: 0;
  }
  #{$element}-uncheck {
    color: rgba($color-black, 0.54);
    @include transition((opacity 0.25s $animation-standard-curve-timing-function));
  }
  #{$element}-ripple {
    width: 44px;
    height: 44px;
    @include border-radius(50%);
    background: rgba($color-black, 0.1);
    top: 0px;
    left: -10px;
    position: absolute;
    @include transition(all 0.2s $animation-standard-curve-timing-function);
    opacity: 0;
    &.active {
      opacity: 1;
    }
  }

  #{$element}-label {
    color: $color-grey-800;
    font-size: 12px;
    top: 0px;
    left: 44px;
    position: absolute;
    height: 44px;
    line-height: 44px;
    width: calc(100% - 44px);
  }
  input[type="radio"] {
    display: none;
    &:checked ~ #{$element}-check {
      @include transform(scale(1));
      opacity: 1;
    }
    &:checked ~ #{$element}-uncheck {
      opacity: 0;
    }
    &:checked ~ #{$element}-ripple {
      background-color: rgba($theme-primary, 0.2);
    }
  }
  input[type="radio"]:disabled,
  input[type="radio"]:checked:disabled {
    pointer-events: none;
    & ~ #{$element}-check,
    & ~ #{$element}-uncheck {
      color: rgba($color-black, 0.26);
    }
  }
  @include generateCreateRadio($element);
}
</style>
